import React from 'react';
import { Button, Popover, Tooltip } from '@material-ui/core';
import Constant from '@/common/constant/Constant';

export default function MoreActionListOrg({
    org,
    moreAction,
    setMoreAction,
    onClickUnlockOrg,
    onClickBlockOrg,
    onClickDeleteOrg,
    popoverId,
    openShareStatusPopover
}) {
    const handleClosePopOver = () => setMoreAction(null);

    const handleClickBlockOrg = (e, orgId) => {
        handleClosePopOver();
        onClickBlockOrg(orgId);
    }
    
    const handleClickUnBlockOrg = (e, orgId) => {
        handleClosePopOver();
        onClickUnlockOrg(orgId);
    }
    
    const handleClickDeleteOrg = (e, orgId) => {
        handleClosePopOver();
        onClickDeleteOrg(orgId);
    }
    return (
        <Popover
            className="navTabs-dropMenu-list-org"
            key={`popover-share-status-${popoverId}`}
            anchorEl={moreAction}
            open={Boolean(moreAction) && popoverId == openShareStatusPopover}
            onClose={handleClosePopOver}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <ul>
                {org.active === Constant.CORPORATION_ACTIVE.BLOCK && (
                    <li id={`unlock-icon-${org.id}`} onClick={e => handleClickUnBlockOrg(e, org.id)}>
                        <span className="navTabs-item">
                            <Tooltip title="停止解除">
                                <Button
                                    className="groupBtnOrgInCorp"
                                >
                                    <img src="/assets/image/unlock-icon.svg" alt="" />
                                </Button>
                            </Tooltip>
                        </span>
                        <span className="navTabs-text">停止解除</span>
                    </li>
                )}
                {org.active === Constant.CORPORATION_ACTIVE.ACTIVE && (
                    <li id={`block-icon-${org.id}`} onClick={e => handleClickBlockOrg(e, org.id)}>
                        <span className="navTabs-item">
                            <Tooltip title="運用停止">
                                <Button
                                    className="groupBtnOrgInCorp"
                                    // onClick={() => alert('jjj')}
                                >
                                    <img src="/assets/image/block-icon.svg" alt="" />
                                </Button>
                            </Tooltip>
                        </span>
                        <span className="navTabs-text">運用停止</span>
                    </li>
                )}
                {[
                    Constant.CORPORATION_ACTIVE.REJECT,
                    Constant.CORPORATION_ACTIVE.WAITING_APPROVE
                ].includes(org.active) && (
                    <li id={`block-ico-disable-${org.id}`}>
                        <span className="navTabs-item">
                            <Tooltip title="運用停止">
                                <span>
                                    <Button
                                        className="groupBtnOrgInCorp"
                                        onClick={e => handleClickBlockOrg(e, org.id)}
                                        disabled={true}
                                    >
                                        <img src="/assets/image/block-ico-disable.svg" alt="" />
                                    </Button>
                                </span>
                            </Tooltip>
                        </span>
                        <span className="navTabs-text">運用停止</span>
                    </li>
                )}
                {org.active === Constant.CORPORATION_ACTIVE.BLOCK && (
                    <li id={`delete-icon-${org.id}`} onClick={e => handleClickDeleteOrg(e, org.id)}>
                        <span className="navTabs-item">
                            <Tooltip title="削除">
                                <Button
                                    className="groupBtnOrgInCorp"
                                >
                                    <img src="/assets/image/delete-icon.svg" alt="" />
                                </Button>
                            </Tooltip>
                        </span>
                        <span className="navTabs-text">削除</span>
                    </li>
                )}
            </ul>
        </Popover>
    );
}
